import Skeleton from "@mui/material/Skeleton";
import { styled } from "@mui/material/styles";
import { CSSProperties, HTMLAttributes } from "react";

import { ProductGalleryV2Wrapper, Mode } from "./ProductGalleryV2Wrapper";

export const DEFAULT_HEIGHT = 560;

type ProductGalleryV2SkeletonProps = {
    height?: number;
} & HTMLAttributes<HTMLDivElement>;

function ProductGalleryV2SkeletonComponent({ height = DEFAULT_HEIGHT, className }: ProductGalleryV2SkeletonProps) {
    const rootStyle = { "--product-gallery-height": `${height}px` } as CSSProperties;

    return (
        <ProductGalleryV2Wrapper data-mode={Mode.SPLIT_TO_4} style={rootStyle} className={className}>
            {new Array(5).fill(undefined).map((_, index) => {
                const imagePlaceholderHeight = index === 0 ? height : height / 2;
                return <Skeleton key={index} height={imagePlaceholderHeight} data-ref="image" variant="rectangular" />;
            })}
        </ProductGalleryV2Wrapper>
    );
}

export const ProductGalleryV2Skeleton = styled(ProductGalleryV2SkeletonComponent)({
    gridArea: "gallery",
});
